import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { getCoinById, recognitionCoin } from "../services/coin_service.tsx";
import { useAuth } from "../services/authContext_service.tsx"; // ✅ DODATO

// slike
const background = require("../assets/analyze/background.png");
const pillar = require("../assets/analyze/pillar.png");
const coinImg = require("../assets/analyze/coin.png");
const field = require("../assets/analyze/field.png");

const analysisCompleted = require("../assets/analyze/analysis completed.png");
const rulerImg = require("../assets/analyze/ruler.png");
const typeImg = require("../assets/analyze/type.png");
const dateImg = require("../assets/analyze/date.png");
const carImg = require("../assets/analyze/car.png");

// NAV
const homeBtn = require("../assets/home button.png");
const yourCoinsBtn = require("../assets/your coins.png");
const numStoriesBtn = require("../assets/num stories button.png");
const signOutBtn = require("../assets/sign out button.png"); // ✅ DODATO

interface CoinAnalysis {
    id: number;
    name_of_emperor?: string;
    type_of_reverse_side?: string;
    dating?: string;
}

const Analyze = () => {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();
    const { logout } = useAuth(); // ✅ DODATO

    const [coin, setCoin] = useState<CoinAnalysis | null>(null);
    const [loading, setLoading] = useState(true);

    const [imagesLoaded, setImagesLoaded] = useState(false);

    useEffect(() => {
        const images = [
            background,
            pillar,
            coinImg,
            field,
            analysisCompleted,
            rulerImg,
            typeImg,
            dateImg,
            carImg,
            homeBtn,
            yourCoinsBtn,
            numStoriesBtn,
            signOutBtn // ✅ DODATO
        ];

        let loaded = 0;

        images.forEach((src) => {
            const img = new Image();
            img.src = src;

            const done = () => {
                loaded++;
                if (loaded === images.length) {
                    setImagesLoaded(true);
                }
            };

            img.onload = done;
            img.onerror = done;
        });
    }, []);

    useEffect(() => {
        const token = localStorage.getItem("accessToken");

        if (!id || !token) {
            navigate("/login");
            return;
        }

        const numericId = Number(id);

        const fetchAndAnalyze = async () => {
            try {
                const coinData = await getCoinById(numericId, token);

                const formData = new FormData();
                const analysisData = await recognitionCoin(formData, token, numericId);

                setCoin({
                    ...coinData,
                    ...analysisData,
                });

            } catch (err) {
                console.log(err);
            } finally {
                setLoading(false);
            }
        };

        fetchAndAnalyze();
    }, [id, navigate]);

    if (loading || !imagesLoaded) {
        return (
            <Box
                sx={{
                    width: "100vw",
                    height: "100vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    background: "black",
                }}
            >
                <CircularProgress size={80} />
            </Box>
        );
    }

    return (
        <Box
            sx={{
                minHeight: "100vh",
                width: "100%",
                backgroundImage: `url(${background})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                position: "relative",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                overflowX: "hidden"
            }}
        >
            <Box
                sx={{
                    mt: 2,
                    display: "flex",
                    justifyContent: "center",
                    gap: { xs: 1, sm: 2, md: 4 },
                    zIndex: 5,
                    flexWrap: "wrap"
                }}
            >
                <img
                    src={homeBtn}
                    style={{ width: "clamp(80px, 15vw, 140px)", cursor: "pointer" }}
                    onClick={() => navigate("/home")}
                />

                <img
                    src={yourCoinsBtn}
                    style={{ width: "clamp(80px, 15vw, 140px)", cursor: "pointer" }}
                    onClick={() => navigate("/view-coins")}
                />

                <img
                    src={numStoriesBtn}
                    style={{ width: "clamp(80px, 15vw, 140px)", cursor: "pointer" }}
                    onClick={() => navigate("/home")}
                />

                <img
                    src={signOutBtn}
                    style={{ width: "clamp(80px, 15vw, 140px)", cursor: "pointer" }}
                    onClick={logout}
                />
            </Box>

            <Box
                component="img"
                src={pillar}
                sx={{
                    position: "absolute",
                    right: 0,
                    bottom: 0,
                    height: "100%",
                    zIndex: 0,
                    display: { xs: "none", md: "block" },
                    opacity: 0.5
                }}
            />

            <Box
                component="img"
                src={carImg}
                sx={{
                    position: "absolute",
                    left: 0,
                    bottom: 0,
                    width: "clamp(220px, 35vw, 420px)",
                    zIndex: 1,
                    display: { xs: "none", md: "block" },
                    opacity: 0.6
                }}
            />

            <Box sx={{ mt: 6, zIndex: 3 }}>
                <img
                    src={analysisCompleted}
                    style={{
                        width: "clamp(200px, 40vw, 300px)"
                    }}
                />
            </Box>

            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 4,
                    mt: 4,
                    px: 2,
                    zIndex: 3
                }}
            >
                <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
                    <Row labelImg={rulerImg} value={coin?.name_of_emperor} />
                    <Row labelImg={typeImg} value={coin?.type_of_reverse_side} />
                    <Row labelImg={dateImg} value={coin?.dating} />
                </Box>

                <Box sx={{ display: { xs: "none", sm: "block" } }}>
                    <img
                        src={coinImg}
                        style={{
                            width: "clamp(200px, 35vw, 280px)",
                            filter: "drop-shadow(0 0 15px purple)"
                        }}
                    />
                </Box>
            </Box>
        </Box>
    );
};

export default Analyze;


const Row = ({ labelImg, value }: { labelImg: string; value?: string }) => {
    const isDate = labelImg === dateImg;
    return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <img
                src={labelImg}
                style={{
                    width: isDate
                        ? "clamp(120px, 28vw, 210px)"
                        : "clamp(150px, 28vw, 210px)"
                }}
            />

            <Box sx={{ position: "relative", width: "clamp(240px, 45vw, 280px)" }}>
                <img src={field} style={{ width: "100%" }} />

                <Typography
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        color: "white",
                        fontWeight: "bold",
                        fontSize: "clamp(12px, 3vw, 14px)",
                        textAlign: "center",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        width: "90%",
                    }}
                >
                    {(value || "No data").replace(/\s+/g, " ")}
                </Typography>
            </Box>
        </Box>
    );
};